import { useEffect } from 'react';
import { useRevealOnScroll } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';

const clients = [
  { name: 'TeknoShop', sector: 'Elektronik & Teknoloji', desc: 'Amazon mağazasına yönelik aylık 800+ gönderi. Fulfillment ve gümrük süreçleri tamamen CargoNet\'e devredildi.', logo: 'ri-computer-line', since: '2019', country: 'DE, UK, FR', ic: '#E8611A', bg: 'rgba(232,97,26,0.1)', border: 'rgba(232,97,26,0.2)' },
  { name: 'ModaEvim', sector: 'Moda & Tekstil', desc: 'Etsy üzerinden Avrupa\'ya butik tekstil ihracatı. Mikro ihracat ve A.TR belgesi hizmetleri kullanılıyor.', logo: 'ri-t-shirt-2-line', since: '2020', country: 'NL, BE, AT', ic: '#9333EA', bg: 'rgba(147,51,234,0.1)', border: 'rgba(147,51,234,0.2)' },
  { name: 'GiftWorld', sector: 'Hediyelik Eşya', desc: 'Orta Doğu\'ya mikro ihracat. A.TR belgesi ve ekspres kurye hizmetleriyle hızlı teslimat.', logo: 'ri-gift-line', since: '2021', country: 'AE, SA, QA', ic: '#16A34A', bg: 'rgba(22,163,74,0.1)', border: 'rgba(22,163,74,0.2)' },
  { name: 'BitkiSel', sector: 'Doğal & Organik', desc: 'Soğuk zincir ile organik ürün ihracatı. Özel iklim kontrollü araçlarla 8 AB ülkesine teslimat.', logo: 'ri-leaf-line', since: '2020', country: '8 AB Ülkesi', ic: '#16A34A', bg: 'rgba(22,163,74,0.1)', border: 'rgba(22,163,74,0.2)' },
  { name: 'TekPart A.Ş.', sector: 'Endüstriyel Parça', desc: 'Makine ve yedek parça ihracatı. Ağır yük uzmanlığı ve özel ambalajlama hizmetleri.', logo: 'ri-settings-3-line', since: '2018', country: 'PL, CZ, DE', ic: '#E8611A', bg: 'rgba(232,97,26,0.1)', border: 'rgba(232,97,26,0.2)' },
  { name: 'ZenHome', sector: 'Ev Dekorasyon', desc: 'eBay ve AliExpress entegrasyonu ile ihracat. Fulfillment merkezi üzerinden otomatik sipariş yönetimi.', logo: 'ri-home-heart-line', since: '2022', country: 'US, CA', ic: '#E11D48', bg: 'rgba(225,29,72,0.1)', border: 'rgba(225,29,72,0.2)' },
  { name: 'SportMax', sector: 'Spor & Outdoor', desc: 'Zalando entegrasyonu ile Avrupa satışları. Hızlı teslimat ve iade yönetimi ile müşteri memnuniyeti.', logo: 'ri-run-line', since: '2021', country: 'ES, IT, GR', ic: '#E8611A', bg: 'rgba(232,97,26,0.1)', border: 'rgba(232,97,26,0.2)' },
  { name: 'GıdaSel', sector: 'Gıda & İçecek', desc: 'Türk gıda ürünleri ihracatı. Sağlık sertifikaları ve soğuk zincir dahil eksiksiz hizmet.', logo: 'ri-restaurant-line', since: '2022', country: 'DE, AU, US', ic: '#16A34A', bg: 'rgba(22,163,74,0.1)', border: 'rgba(22,163,74,0.2)' },
  { name: 'KitapDünyası', sector: 'Yayıncılık & Kültür', desc: 'Türkçe kitapların diasporaya dağıtımı. Avrupa\'daki Türk topluluklarına düzenli teslimat.', logo: 'ri-book-2-line', since: '2019', country: 'Avrupa Diaspora', ic: '#9333EA', bg: 'rgba(147,51,234,0.1)', border: 'rgba(147,51,234,0.2)' },
];

const testimonials = [
  {
    q: 'CargoNet olmadan Amazon mağazamızı bu kadar hızlı büyütemezdik. Fulfillment süreci son derece profesyonel ve güvenilir.',
    name: 'Ahmet Kaya',
    role: 'CEO, TeknoShop',
    img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20male%20executive%20headshot%20dark%20studio%20lighting%20confident%20smile%20business%20suit%20sharp%20focus%20portrait&width=80&height=80&seq=ref3-t1&orientation=squarish',
    stars: 5,
  },
  {
    q: 'Gümrük işlemlerini tamamen devrettik. Artık sadece satışa odaklanıyoruz. Harika bir iş ortağı.',
    name: 'Zeynep Demir',
    role: 'Direktör, ModaEvim',
    img: 'https://readdy.ai/api/search-image?query=professional%20Turkish%20female%20manager%20dark%20studio%20headshot%20business%20casual%20confident%20warm%20smile%20portrait&width=80&height=80&seq=ref3-t2&orientation=squarish',
    stars: 5,
  },
  {
    q: 'On Board Kurye ile kritik belgemiz zamanında ulaştı. Gerçekten hayat kurtardılar! Teşekkürler CargoNet.',
    name: 'Murat Şahin',
    role: 'Kurucu, TekPart A.Ş.',
    img: 'https://readdy.ai/api/search-image?query=young%20Turkish%20entrepreneur%20portrait%20dark%20background%20casual%20business%20friendly%20confident%20smile%20headshot&width=80&height=80&seq=ref3-t3&orientation=squarish',
    stars: 5,
  },
];

const sectors = [
  { icon: 'ri-computer-line', label: 'Elektronik' },
  { icon: 'ri-t-shirt-2-line', label: 'Tekstil' },
  { icon: 'ri-restaurant-line', label: 'Gıda' },
  { icon: 'ri-settings-3-line', label: 'Endüstriyel' },
  { icon: 'ri-leaf-line', label: 'Organik' },
  { icon: 'ri-home-heart-line', label: 'Dekorasyon' },
  { icon: 'ri-run-line', label: 'Spor' },
  { icon: 'ri-book-2-line', label: 'Yayıncılık' },
];

export default function ReferencesPage() {
  useRevealOnScroll();
  useEffect(() => {
    document.title = 'Referanslar | CargoNet – 250+ Şirketin Güvenilir Lojistik Partneri';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main style={{ background: 'var(--bg)', color: 'var(--text1)' }}>

      {/* ── HERO ── */}
      <section className="relative pt-36 pb-24 overflow-hidden" style={{ background: 'var(--bg)' }}>
        <div className="absolute inset-0 pointer-events-none">
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
          <div style={{ position: 'absolute', top: '-200px', right: '-150px', width: 600, height: 600, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="label"><div className="label-dot" />Referanslarımız</div>
              <h1
                className="h-font leading-[0.95] mb-6"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(46px,6vw,80px)', color: 'var(--text1)' }}
              >
                250+ Şirketin<br /><span className="text-gradient">Güvenilir Partneri</span>
              </h1>
              <p style={{ fontSize: 18, color: 'var(--text2)', maxWidth: 480, lineHeight: 1.75, marginBottom: 36 }}>
                E-ticaretten endüstriyele, gıdadan tekstile her sektörden Türk şirketi CargoNet ile dünyaya açılıyor.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link to="/iletisim" className="btn-primary cursor-pointer">
                  Siz de Katılın <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <Link to="/hizmetler" className="btn-ghost cursor-pointer">
                  Hizmetleri İncele
                </Link>
              </div>
            </div>
            <div className="reveal-r">
              <div className="grid grid-cols-4 gap-3">
                {sectors.map((s, i) => (
                  <div
                    key={i}
                    className={`reveal d${Math.min(i + 1, 6)} card-dark p-4 text-center`}
                  >
                    <div
                      className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-2"
                      style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                    >
                      <i className={`${s.icon} text-[#E8611A]`} />
                    </div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text2)' }}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div
                className="mt-4 p-5 rounded-2xl flex items-center gap-4"
                style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
              >
                <div
                  className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0"
                  style={{ background: 'rgba(232,97,26,0.15)', border: '1px solid rgba(232,97,26,0.25)' }}
                >
                  <i className="ri-global-line text-[#E8611A] text-xl" />
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 22, color: 'var(--text1)' }}>24 Ülke</div>
                  <div style={{ fontSize: 13, color: 'var(--text2)' }}>Aktif teslimat ağı, 8 sektör</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CLIENTS ── */}
      <section style={{ background: 'var(--bg2)', padding: '96px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-16">
            <div className="label inline-flex"><div className="label-dot" />Müşterilerimiz</div>
            <h2
              className="reveal h-font leading-[1.1]"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
            >
              Birlikte <span className="text-gradient">Büyüyoruz</span>
            </h2>
            <p className="reveal d2 mt-4" style={{ fontSize: 16, color: 'var(--text2)', lineHeight: 1.7 }}>
              Her sektörden, her büyüklükten şirket CargoNet ile dünyaya açılıyor.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {clients.map((c, i) => (
              <div key={i} className={`reveal d${Math.min(i + 1, 6)} card-dark p-7`}>
                <div className="flex items-start justify-between mb-5">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-2xl"
                    style={{ background: c.bg, border: `1px solid ${c.border}` }}
                  >
                    <i className={`${c.logo} text-xl`} style={{ color: c.ic }} />
                  </div>
                  <span
                    className="text-xs font-bold px-3 py-1.5 rounded-full"
                    style={{ background: 'var(--surface2)', color: 'var(--text3)', border: '1px solid var(--border)' }}
                  >
                    {c.since}&apos;den beri
                  </span>
                </div>
                <h3 style={{ fontWeight: 800, fontSize: 18, color: 'var(--text1)', marginBottom: 4 }}>{c.name}</h3>
                <p style={{ fontSize: 12, fontWeight: 700, color: c.ic, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{c.sector}</p>
                <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.7, marginBottom: 16 }}>{c.desc}</p>
                <div className="flex items-center gap-2" style={{ fontSize: 13, color: 'var(--text3)' }}>
                  <i className="ri-map-pin-line text-[#E8611A]" />
                  <span>{c.country}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section style={{ background: 'var(--bg)', padding: '96px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-16">
            <div className="label inline-flex"><div className="label-dot" />Müşteri Yorumları</div>
            <h2
              className="reveal h-font leading-[1.1]"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
            >
              Müşterilerimiz <span className="text-gradient">Anlatıyor</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            {testimonials.map((t, i) => (
              <div key={i} className={`reveal d${i + 1} card-dark p-8`}>
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: t.stars }).map((_, j) => (
                    <i key={j} className="ri-star-fill text-[#E8611A]" style={{ fontSize: 14 }} />
                  ))}
                </div>
                <p style={{ fontSize: 15, color: 'var(--text2)', lineHeight: 1.8, marginBottom: 28 }}>
                  &ldquo;{t.q}&rdquo;
                </p>
                <div className="flex items-center gap-3 pt-5" style={{ borderTop: '1px solid var(--border)' }}>
                  <div
                    className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0"
                    style={{ border: '2px solid rgba(232,97,26,0.3)' }}
                  >
                    <img src={t.img} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15, color: 'var(--text1)' }}>{t.name}</div>
                    <div style={{ fontSize: 13, color: 'var(--orange)', fontWeight: 600 }}>{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: 'var(--bg2)', padding: '80px 20px', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div
            className="rounded-3xl p-12 text-center relative overflow-hidden"
            style={{ background: 'var(--surface)', border: '1px solid var(--border2)' }}
          >
            <div style={{ position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)', width: 400, height: 400, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%', pointerEvents: 'none' }} />
            <div className="relative">
              <h2 style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(28px,4vw,48px)', color: 'var(--text1)', marginBottom: 12 }}>
                Siz de bu listeye katılın.
              </h2>
              <p style={{ fontSize: 17, color: 'var(--text2)', maxWidth: 480, margin: '0 auto 36px', lineHeight: 1.7 }}>
                Ücretsiz danışmanlık için iletişime geçin. 24 saat içinde size özel teklif hazırlıyoruz.
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/iletisim" className="btn-primary cursor-pointer">
                  Teklif Al <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <a href="tel:+908502420822" rel="nofollow" className="btn-ghost cursor-pointer">
                  <i className="ri-phone-line" /> Hemen Ara
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
